import { render, staticRenderFns } from "./MapLegend.html?vue&type=template&id=6ecd7637&external"
import script from "./MapLegend.vue?vue&type=script&lang=js"
export * from "./MapLegend.vue?vue&type=script&lang=js"
import style0 from "./MapLegend.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports